export default {"src":"/_next/static/media/clouds2.24ec4b6d.svg","height":78,"width":186,"blurWidth":0,"blurHeight":0};